import { Action, createReducer, on } from '@ngrx/store';
import {
  EntityState,
  EntityAdapter,
  createEntityAdapter,
  Update
} from '@ngrx/entity';
import * as VolumeActions from './volume.actions';
import { Volume } from '../../models/volume';
import { VolumeColorMode } from '../../enums/volume';
import { EmergencyTemplate } from '../../models/emergency-template';


export interface State extends EntityState<Volume> {
  selectedId: string | undefined;
  colorMode: VolumeColorMode;
  summary: any;
}

export const adapter: EntityAdapter<Volume> = createEntityAdapter<Volume>();

export const initialState: State = adapter.getInitialState({
  selectedId: undefined,
  colorMode: VolumeColorMode.COLOR_MODE_VOLUME_MOVED,
  summary: undefined,
});

const volumeReducer = createReducer(
  initialState,
  on(VolumeActions.loadVolumes, (state) => {
    return state;
  }),
  on(VolumeActions.loadVolumesSuccess, (state, { volumes }) => {
    return adapter.setAll(volumes, state);
  }),
  on(VolumeActions.loadVolumesFailure, (state, { error }) => {
    return state;
  }),
  on(VolumeActions.clearAllVolumes, (state, {}) => {
    return adapter.removeAll(state);
  }),
  on(VolumeActions.setVolumeColorMode, (state, {colorMode}) => {
    return { ...state, colorMode: colorMode };
  }),
  on(VolumeActions.selectVolume, (state, {id}) => {
    return { ...state, selectedId: id };
  }),
  on(VolumeActions.loadVolumeSummary, (state) => {
    return state;
  }),
  on(VolumeActions.loadVolumeSummarySuccess, (state, { summary }) => {
    return { ...state, summary: summary };
  }),
  on(VolumeActions.loadVolumeSummaryFailure, (state, { error }) => {
    return state;
  }),
  on(VolumeActions.clearVolumeSummary, (state ) => {
    return { ...state, summary: undefined };
  }),
  on(VolumeActions.setVolumeShow, (state, {id, show}) => {
    return adapter.updateOne({id: id, changes: {show : show}}, state);
  }),
  on(VolumeActions.setVolumesShow, (state, {ids, show}) => {
    const updates: Array<Update<any>> = ids.map((id: string) => {
      return { id: id, changes: { show: show } };
    });
    return adapter.updateMany(updates, state);
  }),
);

export function reducer(state: State | undefined, action: Action): any {
  return volumeReducer(state, action);
}

export const getSelectedVolumeId = (state: State) => state.selectedId;
export const getVolumeSummary = (state: State) => state.summary;
